import { RootState } from '../store';

export const selectAverageExpenditure = (state: RootState) =>
  state.averageExpenditure?.data;
